(function(){
  if(window.__OW_RUNTIME_V3__) return;
  window.__OW_RUNTIME_V3__ = true;

  var pageType = window.__OW_PAGE_TYPE__ || '';
  var queue = [];
  var released = false;

  var nativeAppend = Element.prototype.appendChild;
  var nativeInsert = Element.prototype.insertBefore;

  /*
    Keep business/tracking scripts early:
    Google, Meta, Shopify pixels, Simprosys, ByteStand/MCF.
  */
  var keepEarly = /googletagmanager|google-analytics|analytics\.google|googleadservices|doubleclick|connect\.facebook|facebook\.com\/tr|fbevents|shopifycloud\/web-pixels-manager|trekkie|monorail-edge\.shopifysvc|simprosys|simpros|bytestand|byte-stand|mcf|amazon/i;

  /*
    Keep only Yotpo star rating early on product pages.
    This should allow product star rating to render without loading full review fonts/widgets early.
  */
  var yotpoStarsEarly = /staticw2\.yotpo\.com\/.*widget\.js|cdn-widgetsrepository\.yotpo\.com\/v1\/loader|cdn-widgetsrepository\.yotpo\.com\/widget-assets\/widgets-initializer|cdn-widgetsrepository\.yotpo\.com\/.*star-ratings|cdn-widgetsrepository\.yotpo\.com\/.*product-reviews-star-ratings|cdn-widgetsrepository\.yotpo\.com\/.*bottomline/i;

  /*
    Delay heavy Yotpo review/font/style resources.
    This targets Lora/Stawford font CLS and full review widgets.
  */
  var yotpoHeavy = /yotpo-pixel|reviews-widget|review-widget|widgets-css|lora|strawford|cdn-widgetsrepository\.yotpo\.com\/.*(reviews|review|\.woff2|\.woff|\.ttf|\.otf|font|fonts)/i;

  /*
    Other non-critical apps.
  */
  var delayApps = /klaviyo|clarity|geos|sale|hulk|forms|messaging|vizup/i;

  function nodeUrl(node){
    if(!node || !node.tagName) return '';

    var tag = node.tagName;

    if(tag === 'SCRIPT'){
      return node.src || node.getAttribute('src') || '';
    }

    if(tag === 'LINK'){
      return node.href || node.getAttribute('href') || '';
    }

    return '';
  }

  function isDelayableLink(node){
    if(!node || node.tagName !== 'LINK') return false;

    var rel = (node.rel || node.getAttribute('rel') || '').toLowerCase();

    return (
      rel.indexOf('stylesheet') !== -1 ||
      rel.indexOf('preload') !== -1 ||
      rel.indexOf('font') !== -1
    );
  }

  function shouldDelay(node){
    var tag = node && node.tagName;
    var src = nodeUrl(node);

    if(released) return false;
    if(!src) return false;
    if(node.dataset && node.dataset.noDelay === 'true') return false;

    if(tag !== 'SCRIPT' && tag !== 'LINK') return false;
    if(tag === 'LINK' && !isDelayableLink(node)) return false;

    if(keepEarly.test(src)) return false;

    if(pageType === 'product' && yotpoStarsEarly.test(src)){
      return false;
    }

    if(yotpoHeavy.test(src)){
      return true;
    }

    if(delayApps.test(src)){
      return true;
    }

    /*
      Delay most third-party scripts/styles, but keep first-party theme assets normal.
    */
    if(/cdn-widgetsrepository\.yotpo\.com|staticw2\.yotpo\.com|static\.klaviyo\.com|scripts\.clarity\.ms|shopify:\/\/apps/i.test(src)){
      return true;
    }

    return false;
  }

  function hold(parent,node,before,mode){
    if(!shouldDelay(node)) return false;

    if(node.dataset){
      node.dataset.owDelayed = 'true';
    }

    queue.push([parent,node,before,mode]);
    return true;
  }

  Element.prototype.appendChild = function(node){
    return hold(this,node,null,0) ? node : nativeAppend.call(this,node);
  };

  Element.prototype.insertBefore = function(node,before){
    return hold(this,node,before,1) ? node : nativeInsert.call(this,node,before);
  };

  function idle(callback){
    if('requestIdleCallback' in window){
      requestIdleCallback(callback,{timeout:3000});
    } else {
      setTimeout(callback,1500);
    }
  }

  function release(){
    if(released) return;
    released = true;

    Element.prototype.appendChild = nativeAppend;
    Element.prototype.insertBefore = nativeInsert;

    var fallback = document.head || document.body || document.documentElement;

    queue.splice(0).forEach(function(item){
      var parent = document.documentElement.contains(item[0]) ? item[0] : fallback;

      if(item[1].dataset){
        item[1].dataset.owReleased = 'true';
      }

      try{
        if(item[3] && item[2] && item[2].parentNode === parent){
          nativeInsert.call(parent,item[1],item[2]);
        } else {
          nativeAppend.call(parent,item[1]);
        }
      } catch(e){
        nativeAppend.call(fallback,item[1]);
      }
    });

    document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
    document.dispatchEvent(new CustomEvent('StartKernelLoading'));
    window.dispatchEvent(new Event('OwSpeedLoaded'));
  }

  window.owLoadDelayedScripts = release;
  window.loadDelayedShopifyScripts = release;

  ['scroll','touchstart','keydown','click'].forEach(function(eventName){
    window.addEventListener(eventName,function(){
      setTimeout(function(){
        idle(release);
      },700);
    },{once:true,passive:true});
  });

  window.addEventListener('load',function(){
    setTimeout(function(){
      idle(release);
    }, pageType === 'product' ? 9000 : 5500);
  },{once:true});

  setTimeout(function(){
    idle(release);
  }, pageType === 'product' ? 14000 : 9000);
})();